<template>
  <div class="layout" id="ctrl">
    <navigation :class="{nav: true, show: !showNav}" id="head-nav"/>
    <router-view class="view"/>
    <Footer />
  </div>
</template>

<style scoped type="text/css">
.layout {
  padding-top: 65px;
}
.nav {
  position: fixed !important;
  top: 0;
  width: 100%;
  left: 0;
  z-index: 999;
  transition: transform .3s linear;
  transform: translateY(0)
}

.show {
  transform: translateY(-100%)
}

</style>

<script>
import '@/assets/style/reset.css'
import '@/assets/style/public.css'
import navigation from './header'
import footer from './footer'

export default {
  name: 'App',
  data () {
    return {
      showNav: true,
      lastY: 0
    }
  },
  methods: {
    changeHeadState () {
      if (!this.timeout) {
        this.timeout = setTimeout(() => {
          let scrollY = window.scrollY || window.pageYOffset
          // console.log(this.lastY, scrollY)
          if (this.lastY !== scrollY) {
            this.showNav = this.lastY >= scrollY
            this.lastY = scrollY
          }
          this.timeout = null
        }, 30)
      }
    }
  },
  mounted () {
    // this.changeHeadState = this.changeHeadState.bind(this)
    // window.addEventListener('scroll', this.changeHeadState)
  },
  deactivated () {
    // window.removeEventListener('scroll', this.changeHeadState)
  },
  components: {navigation, Footer: footer}
}
</script>



// WEBPACK FOOTER //
// src/pages/layout/index.vue